import { BaseDto } from '../../base/baseDto.model';
export class UpdateCasosUsoRequest extends BaseDto{
  public path?:string
  public icon?:string
  public id_menu?:number
}
